import { poppins400 } from 'theme/common.style';

export const stageCont = (color, font) => ({
  ...poppins400,
  fontSize: font,
  backgroundColor: color,
  padding: '3px 6px',
  borderRadius: '5px',
  color: 'white',
  position: 'absolute',
  right: 0,
});

export const stagePause = (stage, reset) => ({
  position: 'absolute',
  right: stage == 'ST2' && reset == '1' ? 180 : 75,
  paddingTop: '7px',
});

export const stageContMarket = (color, font) => ({
  width: '70px',
  ...poppins400,
  fontSize: font,
  background: color,
  margin: '10px',
  paddingTop: '10px',
  borderRadius: '2px',
  color: 'white',
  position: 'absolute',
  right: '100px',
});

// export const stagePauseMarket = (color, font) => ({
//   position: "absolute",
//   right: "80px",
//   paddingTop:"5px",
// });

export const stageContMarketSt2 = (color, font) => ({
  width: '70px',
  ...poppins400,
  fontSize: font,
  background: color,
  margin: '10px',
  paddingTop: '10px',
  borderRadius: '2px',
  color: 'white',
  position: 'absolute',
  right: '100px',
});

export const stageContMarketStage = (color, font) => ({
  width: 'auto',
  ...poppins400,
  fontSize: font,
  background: color,
  margin: '10px',
  padding: '10px 10px 0px 10px',
  borderRadius: '2px',
  color: 'white',
  position: 'absolute',
  left: '70px',
});

export const counterAlignColumProp = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};
export const counterSubProp = (stage, reset) => ({
  display: 'flex',
  alignItems: 'center',
  // justifyContent: "space-between",
  paddingBottom: '10px',
  paddingTop: '10px',
  position: 'relative',
  flexDirection: stage == 'ST2' && reset == '1' ? 'column' : 'row',
  gap: stage == 'ST2' && reset == '1' ? '20px' : '0px',
});

export const counterSubPropMarket = {
  display: 'flex',
  alignItems: 'center',
  // justifyContent: "space-between",
  // paddingBottom: "10px",
  // paddingTop:"10px",
  position: 'relative',
};
